var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.displayNone)?_c('HeaderSistema',{staticClass:"header__sistema",attrs:{"title":_vm.title,"subtitle":_vm.subtitle}}):_vm._e(),(_vm.displayNone)?_c('BreadSistema',{staticClass:"bread__sistema"}):_vm._e(),_c('router-view',{on:{"update-header":_vm.updateHeader}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }